import React from 'react'
import './experience.css'
import { BiCodeAlt } from 'react-icons/bi'

const Experience = () => {
  return (
    <section id='experience'>
      <h5>SKILLS</h5>
      <h2>TECHNOLOGIES WE'LL USE FOR YOUR PROJECT</h2>

      <div className='container experience__container'>
        <div className="experience__frontend">
          <h3>FrontEnd Development</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
               <div>
               <h4>HTML</h4>
              {/* <small className='text-light'>Experienced</small> */}
               </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>CSS</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>JavaScript</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>Bootstrap</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>Tailwind CSS</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>React</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>

            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
                <h4>Material UI</h4>
                {/* <small className='text-light'>Familiar</small> */}
              </div>
            </article>
          </div>
        </div>

        <div className="experience__backend">
          <h3>BackEnd Development</h3>
          <div className='experience__content'>
          <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>MySQL - Database Administration</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>FLASK WEB FRAMEWORK</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>Java , Spring Boot and Microservices</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>Django</h4>
              {/* <small className='text-light'>Familiar</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>PostgreSQL</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>MongoDB</h4>
              {/* <small className='text-light'>Familiar</small> */}
              </div>
            </article>
          </div>
        </div>

        <div className="experience__ml">
          <h3>Machine Learning</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>Python</h4>
              {/* <small className='text-light'>Familiar</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>EDA</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>Data Visualization</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>Advanced SQL</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>Matplolib, Seaborn, Numpy, Plotly, Streamlit etc</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>SkitLearn & NLTK</h4>
              {/* <small className='text-light'>Familiar</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>HuggingFace Transformers </h4>
              {/* <small className='text-light'>Familiar</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>OpenAi ChatGPT</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>
          </div>
        </div>
        
        <div className="experience__ml">
          <h3>DevOps and Cloud Computing</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>AWS</h4>
              {/* <small className='text-light'>Familiar</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>Linux & Shell Scripting</h4>
              {/* <small className='text-light'>Familiar</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>Docker</h4>
              {/* <small className='text-light'>Experienced</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>Kubernetes</h4>
              {/* <small className='text-light'>Familiar</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>Terraform</h4>
              {/* <small className='text-light'>Familiar</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>Ansible</h4>
              {/* <small className='text-light'>Familiar</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>Jenkins & Github Actions</h4>
              {/* <small className='text-light'>Familiar</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>SonarQube & Argo CD</h4>
              {/* <small className='text-light'>Using the GitOps principle</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>DevSecOps Best Practices</h4>
              {/* <small className='text-light'>Familiar</small> */}
              </div>
            </article>
            <article className='experience__details'>
              <BiCodeAlt className='experience__details-icon' />
              <div>
              <h4>GitOps Best Practices</h4>
              {/* <small className='text-light'>Familiar</small> */}
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience;